import React, { Component } from 'react';

import getMyMap, {createAreasMassLayer, createNamesLayer, createCommunesNamesLayerEasy, createCommuneMassLayer, createCommunesLayer, getLegendMode} from '../b-LeafletMap/leaflet_map';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';
import Info from '../f-Utilities/Info';
import Sources from '../f-Utilities/Sources'

import {c_missing_data, c_gradient_reds_greens} from '../a-Graphic/Colors';

class Incomes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: "median_income",
      legend_label: "(revenu disponible par mois par unité de consommation du ménage - €)"
    };

    this.colors = c_gradient_reds_greens.slice(2, 8)
  }

  displayCategory = (cat, legend_label) => {
      this.setState({
        selected: cat,
        legend_label: legend_label,
      })
  }

  getCommunes(){
    /* COMMUNES */
    var communes = this.props.territory.communes;

    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    if(this.state.selected == "median_income"){
      var communes_nd = communes.filter((c) => c.median_income == null)
      var communes_wd = communes.filter((c) => c.median_income != null)
      var communes_masses = communes_wd.map((c) => Math.round(c.median_income/12));
      var communes_labels = communes_wd.map((c) => c.name + " - " + Math.round(c.median_income/12) + " €/mois/uc</br>");
      var mode = "revenues"
      var colors = this.colors
    }
    else if(this.state.selected == "gini"){
      var communes_nd = communes.filter((c) => c.gini == null)
      var communes_wd = communes.filter((c) => c.gini != null)
      var communes_masses = communes_wd.map((c) => c.gini);
      var communes_labels = communes_wd.map((c) => c.name + " - " + Math.round(c.gini*100)/100);
      var mode = "gini"
      var colors = this.colors.slice().reverse()
    }
    else if(this.state.selected == "decile_ratio"){
      var communes_nd = communes.filter((c) => c.decile_ratio == null)
      var communes_wd = communes.filter((c) => c.decile_ratio != null)
      var communes_masses = communes_wd.map((c) => c.decile_ratio);
      var communes_labels = communes_wd.map((c) => c.name + " - " + c.decile_ratio);
      var mode = "d1/9"
      var colors = this.colors.slice().reverse()
    }
    return {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors}
  }

  componentDidMount() {
    let {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors} = this.getCommunes()

    // --- init map
    var mymap = this.mymap = getMyMap("incomes", true, 0.3);

    // --- create layers
    var communes_layer = this.communes_layer = createCommuneMassLayer(mymap, communes_wd, communes_masses, communes_labels, mode, colors);
    var communes_layer_2 = this.communes_layer_2 = createCommunesLayer(mymap, communes_nd, null, c_missing_data);
    //var names_layer = this.names_layer = createNamesLayer(mymap, communes_coords, communes_names);
    createCommunesNamesLayerEasy(mymap, this.props.territory.communes)

    // ---update legend
    let legend = getLegendMode(mode, communes_masses, this.colors)
    this.setState({legend: legend})

    // --- center the map
    mymap.fitBounds(communes_layer.addLayer(communes_layer_2).getBounds());
  }

  componentDidUpdate(prevProps, prevState) {
    // --- update
    this.mymap.removeLayer(this.communes_layer);
    this.mymap.removeLayer(this.communes_layer_2);

    let {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors} = this.getCommunes()

    // --- create layers;
    var communes_layer = this.communes_layer = createCommuneMassLayer(this.mymap, communes_wd, communes_masses, communes_labels, mode, colors);
    var communes_layer_2 = this.communes_layer_2 = createCommunesLayer(this.mymap, communes_nd, null, c_missing_data);

    // --- center the map
    this.mymap.fitBounds(communes_layer.addLayer(communes_layer_2).getBounds());
  }

  render() {
    let communes = this.props.territory.communes;
    let {communes_nd, communes_wd, communes_masses, communes_labels, mode, colors} = this.getCommunes()
    let missing_data = communes_nd.length > 0

    let [legend_intervals, legend_colors] = getLegendMode(mode, communes_masses, colors)

    return(
          <div className="row content mt-4 mb-5">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">revenus</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 line-border">
                    <p
                    className={this.state.selected === "median_income" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "median_income", "(revenu disponible par mois par unité de consommation du ménage - €)")}>niveau de vie médian</p>
                    <p
                    className={this.state.selected === "gini" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "gini", "(indice de Gini)")}>indice de Gini</p>
                    <p
                    className={this.state.selected === "decile_ratio" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "decile_ratio", "(écart interdécile)")}>écart interdécile</p>
                  </div>
                </div>


                <div className="row mt-5">
                  <div className="col-12">
                    <p className="mb-1">Le niveau de vie médian est de <b>1828/mois/uc en France</b>. <Info content="Le niveau de vie est égal au revenu disponible du ménage divisé par le nombre d'unités de consommation (uc). Il est ici calculé sur le revenu disponible qui correspond aux revenus auxquels il faut ajouter les prestations sociales et retirer les impôts directs." /></p>
                    <p className="mb-1">L'indice de Gini reflète les inégalités globales. A l'échelle nationale il est de <b>0,29</b>.</p>
                    <p className="mb-3">L'écart interdécile est de <b>3,4</b> en France.<Info content="L'écart interdécile est le rapport entre le revenu des 10% les plus riches et celui des 10% les plus pauvres. Il traduit les inégalités ponctuelles." /></p>
                  </div>
                </div>
            </div>

            <div className="col-9">
              <div className="row align-items-end">
                <div className="col-10">
                  <div style={{height: "500px"}} id="incomes"></div>
                </div>
                <div className="col-2 pl-0 pr-0">
                     <LegendCommune label={this.state.legend_label}/>
                     <LegendValues intervals={legend_intervals}
                                   colors={legend_colors}
                                   missing_data={missing_data}/>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col">
                 <Sources sources={this.props.territory.sources}
                        concerned={["incomes"]}/>
                </div>
              </div>
            </div>

          </div>
    )
  }
}

export default Incomes;
